import { render, staticRenderFns } from "./ImportJson.vue?vue&type=template&id=76f80d6a&scoped=true"
import script from "./ImportJson.vue?vue&type=script&lang=js"
export * from "./ImportJson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f80d6a",
  null
  
)

export default component.exports